<!-- MULTI SELECTION CHIPS -->
<div *ngIf="multiSelection && values && values.length > 0" class="chips-cnt">
    <div *ngFor="let item of values" class="tc-chip" [ngClass]="{'tc-readonly': readOnly}">
        <span class="tc-span">{{item}} </span>
        <i *ngIf="!readOnly" class="fal fa-times tc-icon" (click)="onDeleteValue($event, item)"></i>
    </div>
</div>

<!-- SINGE SELECTION CHIP -->
<div *ngIf="!multiSelection" class="chips-cnt">
    <div class="tc-chip-single" [ngClass]="{'tc-readonly': readOnly}">
        <span class="tc-span">{{value}} </span>
        <i *ngIf="!readOnly && value && allowSingleSelectionClear" class="fal fa-times tc-icon" (click)="onDeleteValue($event, value)"></i>
    </div>
</div>
